import arLocale from 'vee-validate/dist/locale/ar.json';

const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  title: 'إصدار عقد إلكترونياً',
  iqama: 'إقامة',
  nationalUnifiedNumber: 'الرقم الوطني الموحد',
  nationalId: 'هوية وطنية',
  nationalIdLabel: 'رقم الهوية',
  iqamaLabel: 'رقم الإقامة',
  mobileRequired: 'رقم الجوال مطلوب',
  mobileInvalid: 'رقم الجوال غير صحيح',
  nationalIdPlaceholder: 'الرجاء إدخال رقم الهوية',
  iqamaPlaceholder: 'الرجاء إدخال رقم الإقامة',
  error: 'خطأ',
  success: 'نجاح',
  serverErrors: {
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
  },
  fields: {
    email: 'البريد الاليكتروني',
    mobile: 'رقم الجوال',
    nationalId: 'رقم الهوية',
    iqama: 'رقم الإقامة',
    birthdate: 'تاريخ الميلاد',
    lawyerLicenseNo: 'رقم رخصة المحاماه',
    contractCode: 'رقم وثيقة العقد',
    requesterNationalId: 'رقم هوية المتحقق',
    contractCreationDate: 'تاريخ إصدار الوثيقة',
    recaptcha: 'الريكابتشا',
    contractStartDate: 'تاريخ بداية العقد',
    contractEndDate: 'تاريخ نهاية العقد',
    number: 'رقم',
    amount: 'مبلغ مالي',
    date: 'تاريخ',
    city: 'مدينة',
    iban: 'الأيبان',
    hijri: 'تاريخ هجري',
    gregorian: 'تاريخ ميلادي',
    text: 'نص',
    time: 'وقت',
    district: 'الحي',
    country: 'الدولة',
    firstPartner: 'الطرف الأول',
    secondPartner: 'الطرف الثاني',
    lawyer: 'المحامي',
    otp: 'رمز التحقق',
    reason: 'السبب',
  },
  validation: {
    ...arLocale.messages,
    mobile: '{_field_} المدخل غير صحيح يجب أن يبدأ بـ(05) و لا يزيد عن 10 أرقام',
    nationalId: '{_field_} غير صالح',
    iqama: '{_field_} غير صالح',
    required: 'حقل {_field_} مطلوب',
    requesterNationalId: 'رقم الهوية غير صالح',
    date: '{_field_} غير صالح',
    lessThan18: 'لا يمكن تقديم الطلب، لأن الطرف قاصر سناً',
    minimumContractDuration: 'يجب أن يكون تاريخ انتهاء العقد بعد 90 يوم أو أكثر من تاريخ بداية العقد',
    otp: 'حقل {_field_} غير صالح',
  },
};

export default ar;
